import {defineLocale} from 'ngx-bootstrap/chronos';
import {
  arLocale,
  deLocale,
  enGbLocale,
  esLocale,
  frLocale,
  itLocale,
  nlLocale,
  ptBrLocale,
  ruLocale,
  zhCnLocale
} from 'ngx-bootstrap/locale';

export function loadBsLocales() {
  defineLocale('fr-fr', frLocale);
  defineLocale('fr-lu', frLocale);
  defineLocale('ru-ru', ruLocale);
  defineLocale('ar-eg', arLocale);
  defineLocale('it-it', itLocale);
  defineLocale('es-es', esLocale);
  defineLocale('en-au', enGbLocale);
  defineLocale('zh-cn', zhCnLocale);
  defineLocale('nl-nl', nlLocale);
  defineLocale('pt-pt', ptBrLocale);
  defineLocale('en-gb', enGbLocale);
  defineLocale('de-de', deLocale);
}
